var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransactionTopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5C2.343 8.5 1 9.843 1 11.5C1 13.157 2.343 14.5 4 14.5C5.657 14.5 7 13.157 7 11.5C7 9.843 5.657 8.5 4 8.5ZM5.75 12H4.5V13.25C4.5 13.388 4.388 13.5 4.25 13.5H3.75C3.612 13.5 3.5 13.388 3.5 13.25V12H2.25C2.112 12 2 11.888 2 11.75V11.25C2 11.112 2.112 11 2.25 11H3.5V9.75C3.5 9.612 3.612 9.5 3.75 9.5H4.25C4.388 9.5 4.5 9.612 4.5 9.75V11H5.75C5.888 11 6 11.112 6 11.25V11.75C6 11.888 5.888 12 5.75 12Z",
    fill: "#DB7802"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 5.5H15V8H13.25C12.561 8 12 7.439 12 6.75C12 6.061 12.561 5.5 13.25 5.5Z",
    fill: "#DB7802"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9V11C15 11.5525 14.5525 12 14 12H7.9655C8.316 9.194 5.7435 6.9235 3 7.631V2C3 1.724 3.224 1.5 3.5 1.5H14C14.5525 1.5 15 1.9475 15 2.5V4.5H13.25C12.0095 4.5 11 5.5095 11 6.75C11 7.9905 12.0095 9 13.25 9H15Z",
    fill: "#DB7802"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionTopup);
export default __webpack_public_path__ + "static/media/icon_transaction_topup.e7d0d428f12062ebb62b43091171e4c0.svg";
export { ForwardRef as ReactComponent };